// Localização: frontend/src/context/ProntuarioFilterContext.jsx
// Contexto compartilhado para filtros de período nas abas do prontuário

import React, { createContext, useContext, useState, useCallback } from 'react';

const ProntuarioFilterContext = createContext(undefined);

/**
 * Provider para compartilhar filtros de período entre as abas do prontuário
 * Permite que múltiplas abas compartilhem o mesmo estado de filtro de período
 */
export const ProntuarioFilterProvider = ({ children }) => {
    const [periodo, setPeriodo] = useState('');
    const [periodoStartDate, setPeriodoStartDate] = useState('');
    const [periodoEndDate, setPeriodoEndDate] = useState('');

    /**
     * Handler para mudanças no período (ex: 'hoje', 'semana', 'mes')
     * @param {string} newPeriodo - Novo período selecionado
     */
    const handlePeriodoChange = useCallback((newPeriodo) => {
        setPeriodo(newPeriodo || '');
    }, []);

    /**
     * Handler para mudanças no intervalo de datas
     * @param {string} newStartDate - Nova data inicial (formato YYYY-MM-DD)
     * @param {string} newEndDate - Nova data final (formato YYYY-MM-DD)
     */
    const handleDateRangeChange = useCallback((newStartDate, newEndDate) => {
        const startDateStr = newStartDate || '';
        const endDateStr = newEndDate || '';
        
        // Só atualizar se os valores realmente mudaram
        if (periodoStartDate !== startDateStr || periodoEndDate !== endDateStr) {
            setPeriodoStartDate(startDateStr);
            setPeriodoEndDate(endDateStr);
        }
    }, [periodoStartDate, periodoEndDate]);

    const value = {
        periodo,
        periodoStartDate,
        periodoEndDate,
        handlePeriodoChange,
        handleDateRangeChange
    };

    return (
        <ProntuarioFilterContext.Provider value={value}>
            {children}
        </ProntuarioFilterContext.Provider>
    );
};

/**
 * Hook para acessar o contexto de filtros do prontuário
 * @throws {Error} Se usado fora do ProntuarioFilterProvider
 */
export const useProntuarioFilter = () => {
    const context = useContext(ProntuarioFilterContext);
    
    if (context === undefined) {
        throw new Error('useProntuarioFilter deve ser usado dentro de ProntuarioFilterProvider');
    }
    
    return context;
};

